import React, { FC, ReactNode } from 'react'
import './icon.scss'

export const HousingIndustryConstructionIcon: FC<ReactNode> = () => {
  return (
    <div className='icon-container'>
      <img
        srcSet={
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/6985a6c6707a53a4e2fa269eb45c08c5_IS24_Housing%20Construction_highlighter.png, ' +
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/24d1c4dbcdf3d953ee5d1a5d15eed87f_IS24_Housing%20Construction_highlighter@2x.png, ' +
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/52a086a0f1e5c936e50c602dc78572e1_IS24_Housing%20Construction_highlighter@3x.png'
        }
        src={
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/6985a6c6707a53a4e2fa269eb45c08c5_IS24_Housing%20Construction_highlighter.png'
        }
        width={90}
        height={87}
        alt={''}
      />
    </div>
  )
}
